import CmpScrollMultipleOptionList from "./CmpScrollMultipleOptionList";

export default CmpScrollMultipleOptionList;